import axios from "axios";
import { FORGET_PASSWORD_URL, getAuthHeader } from "../../configuration/Utils/constService";

export const forgetPassword = (data) => axios.post(FORGET_PASSWORD_URL, data, getAuthHeader());